import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import { RadioGroup, FormControlLabel, Radio, Typography } from '@material-ui/core';
import { theme } from 'fpay-ui';
import { useTranslation } from 'react-i18next';
import { isAllowed } from 'helpers/auth';

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 32px 16px 32px 16px;
  flex-direction: column;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  color: #444b62;
  margin-bottom: 16px;
`;
const ConstainerButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 24px;
  ${theme.breakpoint('md')} {
    justify-content: flex-end;
    /* margin-top: -138px; */
  }
`;
const fontTypes = {
  button: css`
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: normal;
  `,
};

const Button = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    ${fontTypes.button}
    text-align: center;
    align-items: center;
    width: 97px;
    height: 48px;
    border-radius: 6px;
    pointer-events: ${(props) => props.disabled && 'none'};
    background-color: ${(props) =>
      props.noThanks ? '#ffffff' : props.disabled ? '#E4E6EB' : `${theme.colors.gbrand500}`};
    color: ${(props) =>
      props.noThanks ? `${theme.colors.gbrand500}` : props.disabled ? '#A2A7BA' : '#ffffff'};
    cursor: pointer;
    transition: all 0.3s ease 0s;
    &:hover {
      box-shadow: ${(props) => (props.noThanks ? '' : '0 1px 6px rgb(32 33 36 / 28%)')};
      background-color: ${(props) => (props.noThanks ? '' : `${theme.colors.gbrand600}`)};
      color: ${(props) => (props.noThanks ? `${theme.colors.gbrand600}` : '#ffffff')};
    }
    &:active {
      border: ${(props) => (props.noThanks ? '' : `1px solid ${theme.colors.gbrand500}`)};
    }
  `
);

const ReportsMenu = ({ handleClick, handleClose, page, handleChange, value }) => {
  const { breakpoint } = useBreakpoints();
  const { t } = useTranslation();

  return (
    <Container style={{ justifyContent: 'space-between', height: '100%' }}>
      <Title>{t('reportsScreen.createTitle')}</Title>
      <RadioGroup
        aria-labelledby="radio-buttons-group"
        name="Flujo de Reportes"
        value={value}
        onChange={handleChange}
        page={value}
      >
        {isAllowed('REPORT_AVAILABLE_DATE_RANGE') && (
          <FormControlLabel
            name="DATA_RANGE"
            testId="DATA_RANGE"
            value="DATA_RANGE"
            label={
              <Typography style={{ fontSize: 14, color: '#444B62' }}>
                {t('reportsScreen.rangeTime')}
              </Typography>
            }
            control={<Radio />}
            labelPlacement="start"
            style={{
              width: breakpoint === 'xs' ? 264 : 360,
              justifyContent: 'space-between',
              marginLeft: 0,
              fontSize: 14,
            }}
          />
        )}
        {isAllowed('REPORT_AVAILABLE_CUSTOM') && (
          <FormControlLabel
            name="CUSTOM"
            testId="CUSTOM"
            value="CUSTOM"
            label={
              <Typography style={{ fontSize: 14, color: '#444B62' }}>
                {t('reportsScreen.content')}
              </Typography>
            }
            control={<Radio />}
            labelPlacement="start"
            style={{
              width: breakpoint === 'xs' ? 264 : 360,
              justifyContent: 'space-between',
              marginLeft: 0,
            }}
          />
        )}
        {isAllowed('REPORT_AVAILABLE_SCHEDULED') && (
          <FormControlLabel
            name="SCHEDULED"
            testId="SCHEDULED"
            value="SCHEDULED"
            label={
              <Typography style={{ fontSize: 14, color: '#444B62' }}>
                {t('reportsScreen.program')}
              </Typography>
            }
            control={<Radio />}
            labelPlacement="start"
            style={{
              width: breakpoint === 'xs' ? 264 : 360,
              justifyContent: 'space-between',
              marginLeft: 0,
            }}
          />
        )}
      </RadioGroup>
      <ConstainerButtons>
        <Button noThanks onClick={handleClose} id="cancel-create-report">
          {t('reportsScreen.cancel')}
        </Button>
        <Button onClick={handleClick} disabled={!value} id="confirm-create-report">
          {t('reportsScreen.continue')}
        </Button>
      </ConstainerButtons>
    </Container>
  );
};

export default ReportsMenu;
